// Rolldown's CJS wrapping prevents prismjs from setting window.Prism as a
// global. We import it here and assign it explicitly so that @lexical/code's
// prism language component imports (prism-clike, etc.) can find it.
import Prism from 'prismjs';

(globalThis as Record<string, unknown>).Prism = Prism;
